var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"35df85ac023ea7eeadf1d9e986572ec0c126e528"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import { env } from '@kc-console/context';
import { captureConsoleIntegration } from '@sentry/integrations';
import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: env.KC_SENTRY_DSN,
  release: env.KC_RELEASE_TAG,
  integrations: [
    captureConsoleIntegration({
      levels: ['warn', 'error', 'debug'],
    }),
  ],
  beforeBreadcrumb(breadcrumb, hint) {
    if (breadcrumb.category === 'ui.click' && hint) {
      const { target } = hint.event;

      if (target.ariaLabel) {
        breadcrumb.message = target.ariaLabel;
      }
    }

    return breadcrumb;
  },
  autoSessionTracking: false,
});
